import { useMemo } from 'react';

import { useTheme } from '@frontend/components';

export const buildGirlPodStyles = (theme: Theme) => ({
  '--chakra-fonts-default': `"Comic Sans MS", "Comic Sans", cursive, ${theme.fonts.default}`, // Apply Comic Sans font to the header

  '--chakra-colors-page-plateLight': '#E9F5F1',

  '--chakra-colors-feature-primary': '#071813',
  '--chakra-colors-feature-secondary': '#6B7C77',

  '--chakra-colors-alert-surfaceError': '#FFC8A1',
  '--chakra-colors-alert-error': '#FA8B3C',
  '--chakra-colors-alert-assistance': '#F55D8D',
  '--chakra-colors-alert-surfaceAssistance': '#FFCBEA',

  '--chakra-colors-interaction-main': '#0A7354',
  '--chakra-colors-interaction-active': '#09543E',
  '--chakra-colors-interaction-hover': '#6FDC9E',
  '--chakra-colors-interaction-surfaceHover': '#FFF5AD',
  '--chakra-colors-interaction-surfaceActive': '#FEEB5B',

  '--chakra-colors-interaction-suggestion': '#F55D8D',
  '--chakra-colors-interaction-suggestionHover': '#FE6F9C',
  '--chakra-colors-interaction-suggestionActive': '#E74176',
  '--chakra-colors-interaction-surfaceSuggestionHover': '#FFCBEA',
  '--chakra-colors-interaction-surfaceSuggestionActive': '#FF94D4',

  '--chakra-shadows-focus': '0 0 0px 3px #43D08058',
  '--chakra-shadows-focusInset': 'inset 0 0 0px 3px #43D08058',
});

export const useEasterEgg = (rootPartNumber?: string | null) => {
  const theme = useTheme();

  const isActive = useMemo(
    () => rootPartNumber === 'girl pod<3',
    [rootPartNumber],
  );

  const modalStyles = useMemo(() => buildGirlPodStyles(theme), [theme]);

  return useMemo(
    () => ({
      isActive,
      modalStyles,
      actionText: {
        checkBom: 'Half Send',
        publishBom: 'Full Send',
      },
    }),
    [isActive, modalStyles],
  );
};
